import React from 'react';
import {MdTextField, MdCheckbox} from 'core/components/fields/fields';
import FlatButton from 'material-ui/FlatButton';
import moment from "moment";
import Axios from 'core/common/config/axios-config';
import StyledDatePicker from 'core/components/fields/styledDatePicker';
import Toolmenu from 'core/components/toolmenu/toolmenu';
import {screenLg} from 'core/common/config/variables';

interface ResponsiveTestState {
  screenWidth?: number;
  viewportWidth?: number;
  bodyClientWidth?: number;
  documentClientWidth?: number;
  checkboxValue?: boolean;
}

export default class ResponsiveTest extends React.Component<undefined, ResponsiveTestState> {

  static title = 'Responsive Test';
  static icon = 'home';

  mq: MediaQueryList;

  state = this._createSizeObject();

  _createSizeObject() {
    const widths = {
      screenWidth: window.screen.width,
      viewportWidth: window.innerWidth,
      bodyClientWidth: document.body.clientWidth,
      documentClientWidth: document.documentElement.clientWidth,
      checkboxValue: true
    };
    console.log('widths: ', widths);
    return widths;
  }

  onResize = (evt) => {
    this.setState(this._createSizeObject());
  };

  componentWillMount() {

    this.mq = window.matchMedia('only screen and (min-width: ' + screenLg + 'px)');
    if(this.mq.matches) {
      console.log('the width of browser is more then ' + screenLg);
    } else {
      console.log('the width of browser is less then ' + screenLg);
    }

    this.mq.addListener((changed) => {
      if(changed.matches) {
        console.log('the width of browser is more then ' + screenLg);
      } else {
        console.log('the width of browser is less then ' + screenLg);
      }
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);



  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    this.mq.removeListener(this.onResize);
  }

  onChecked = (e) => {
    console.log('onChecked ', e.target.value, e.target.checked);
    this.setState({checkboxValue: e.target.checked as boolean});
  };

  onDateTest = (e) => {
    let invoiceDate = '2016-07-25';

    let startInvoicePeriod = moment(invoiceDate).startOf('month').toISOString();
    let endInvoicePeriod = moment(invoiceDate).endOf('month').startOf('day').toISOString();

    console.log('startInvoicePeriod ', startInvoicePeriod);
    console.log('endInvoicePeriod ', endInvoicePeriod);

    let struct = {
      localDate1: startInvoicePeriod,
      localDate2: endInvoicePeriod,
      localDateTime1: startInvoicePeriod,
      localDateTime2: endInvoicePeriod,
      instant1: startInvoicePeriod,
      instant2: endInvoicePeriod,
      zonedDateTime1: startInvoicePeriod,
      zonedDateTime2: endInvoicePeriod
    };

    Axios.post('/public/test/dates', struct)
      .then((response) => {
        console.log(response);
      });
  };


  onDateTest2 = (e) => {
    let invoiceDate = '2016-07-25';

    let startInvoicePeriod = moment(invoiceDate).startOf('month').format("YYYY-MM-DD");
    let endInvoicePeriod = moment(invoiceDate).endOf('month').startOf('day').format("YYYY-MM-DD");

    console.log('startInvoicePeriod ', startInvoicePeriod);
    console.log('endInvoicePeriod ', endInvoicePeriod);

    let struct = {
      localDate1: startInvoicePeriod,
      localDate2: endInvoicePeriod,
    };

    Axios.post('/public/test/dates', struct)
      .then((response) => {
        console.log(response);
      });
  };


  render() {


    const {screenWidth, viewportWidth, bodyClientWidth, documentClientWidth} = this.state;

    return (

      <main className="main-content">
        <Toolmenu>
          <div>
            window.screen.width: {screenWidth}
          </div>
          <div>
            window.innerWidth: {viewportWidth}
          </div>
          <div>
            document.body.clientWidth: {bodyClientWidth}
          </div>
          <div>
            document.documentElement.clientWidth: {documentClientWidth}
          </div>
        </Toolmenu>
        <form>
            <div className="row" >
              <div className="col-xs-12" >
                <div className="box" style={{backgroundColor: 'blue', color: 'white', marginTop:10}}>
                  col-xs  &lt; 768px
                </div>
              </div>
            </div>
            <div className="row" >
              <div className="col-xs-12">
                <div className="box" style={{backgroundColor: 'blue', color: 'white'}}>
                  768px &lt;= col-sm  &lt; 992px
                </div>
              </div>
            </div>
            <div className="row" >
              <div className="col-xs-12">
                <div className="box" style={{backgroundColor: 'blue', color: 'white'}}>
                  992px &lt;= col-md  &lt; 1200px
                </div>
              </div>
            </div>
            <div className="row" >
              <div className="col-xs-12">
                <div className="box" style={{backgroundColor: 'blue', color: 'white'}}>
                  1200px &lt;= col-lg
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12">
                <div className="box" style={{backgroundColor: 'lightGrey', marginTop:10,marginBottom:10}}>
                  col-xs-12
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <div className="box" style={{backgroundColor: 'lightGrey', marginTop:10,marginBottom:10}}>
                  col-xs-12 col-sm-8
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-8 col-md-6">
                <div className="box" style={{backgroundColor: 'lightGrey', marginTop:10,marginBottom:10}}>
                  col-xs-12 col-sm-8 col-md-6
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-8 col-md-6 col-lg-4">
                <div className="box" style={{backgroundColor: 'lightGrey', marginTop:10,marginBottom:10}}>
                  col-xs-12 col-sm-8 col-md-6 col-lg-4
                </div>
              </div>
            </div>

            <hr/>

            <div className="row">
              <div className="col-xs-12 col-md-6 col-lg-4">
                <div className="box" style={{backgroundColor: 'yellow', marginTop:10,marginBottom:10}}>
                  col-xs-12 col-sm-8 col-md-6 col-lg-4
                </div>
              </div>
              <div className="col-xs-12  col-md-6 col-lg-4">
                <div className="box" style={{backgroundColor: 'yellow', marginTop:10,marginBottom:10}}>
                  col-xs-12 col-sm-8 col-md-6 col-lg-4
                </div>
              </div>
              <div className="col-xs-12 col-md-6 col-lg-4">
                <div className="box" style={{backgroundColor: 'yellow', marginTop:10,marginBottom:10}}>
                  col-xs-12 col-sm-8 col-md-6 col-lg-4
                </div>
              </div>
            </div>


          <StyledDatePicker defaultValue={new Date()}  style={{marginRight: '20px'}} placeholder="Datum narozeni" />
          <StyledDatePicker defaultValue={new Date()}  style={{marginRight: '20px'}} floatingLabelText="Datum narozeni" />

          <MdTextField defaultValue={'1000'}  />

          <MdCheckbox  name="checkboxName"
                     checked={this.state.checkboxValue}
                     label="went for a run today" onCheck={this.onChecked}/>

          <FlatButton label="onDateTest"  onClick={this.onDateTest}/>
          <FlatButton label="onDateTest2"  onClick={this.onDateTest2}/>

        </form>
      </main>
    )
      ;
  }

}



// WEBPACK FOOTER //
// ./src/administration/responsiveTest.tsx